module.exports = __webpack_public_path__ + "media/images/home-jobseekers-6d08100e83ba56612efc55dfbf64df1b.png";